// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xzWf3","largestCol":"styles_largestCol__SDn2N","smallestCol":"styles_smallestCol__2AjAR"};